import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class TokenService {
  private readonly TOKEN_KEY = 'token';

  /** Almacenar el token */
  setToken(token: string): void {
    sessionStorage.setItem(this.TOKEN_KEY, token);
  }

  /** Obtener el token */
  getToken(): string | null {
    const token = sessionStorage.getItem(this.TOKEN_KEY);
    return token && !this.isTokenExpired(token) ? token : null;
  }

  /** Eliminar el token */
  removeToken(): void {
    sessionStorage.removeItem(this.TOKEN_KEY);
  }

  /** Verificar si el token es válido */
  isTokenValid(): boolean {
    const token = this.getToken();
    return token !== null;
  }

  /** Verificar si el token ha expirado */
  private isTokenExpired(token: string): boolean {
    const payload = this.decodeToken(token);
    if (!payload || !payload.exp) return true;

    return new Date().getTime() >= payload.exp * 1000;
  }

  /** Decodificar el token JWT */
  private decodeToken(token: string): any {
    try {
      const payload = atob(token.split('.')[1]);
      return JSON.parse(payload);
    } catch (error) {
      return null;
    }
  }
}
